/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dialogue_List_Export_General_OptionsInputs */

const en_dialogue_list_export_general_options = /** @type {(inputs: Dialogue_List_Export_General_OptionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`General Options`)
};

const fr_dialogue_list_export_general_options = /** @type {(inputs: Dialogue_List_Export_General_OptionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Options générales`)
};

const de_dialogue_list_export_general_options = /** @type {(inputs: Dialogue_List_Export_General_OptionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Allgemeine Optionen`)
};

const it_dialogue_list_export_general_options = /** @type {(inputs: Dialogue_List_Export_General_OptionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Opzioni generali`)
};

const ru_dialogue_list_export_general_options = /** @type {(inputs: Dialogue_List_Export_General_OptionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Общие параметры`)
};

const es_dialogue_list_export_general_options = /** @type {(inputs: Dialogue_List_Export_General_OptionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Opciones generales`)
};

const zh_cn2_dialogue_list_export_general_options = /** @type {(inputs: Dialogue_List_Export_General_OptionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`一般选项`)
};

const ja_dialogue_list_export_general_options = /** @type {(inputs: Dialogue_List_Export_General_OptionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`一般オプション`)
};

const hi_dialogue_list_export_general_options = /** @type {(inputs: Dialogue_List_Export_General_OptionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`आम विकल्प`)
};

const pt_pt2_dialogue_list_export_general_options = /** @type {(inputs: Dialogue_List_Export_General_OptionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Opções gerais`)
};

/**
* | output |
* | --- |
* | "General Options" |
*
* @param {Dialogue_List_Export_General_OptionsInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const dialogue_list_export_general_options = /** @type {((inputs?: Dialogue_List_Export_General_OptionsInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dialogue_List_Export_General_OptionsInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_dialogue_list_export_general_options(inputs)
	if (locale === "de") return de_dialogue_list_export_general_options(inputs)
	if (locale === "it") return it_dialogue_list_export_general_options(inputs)
	if (locale === "ru") return ru_dialogue_list_export_general_options(inputs)
	if (locale === "es") return es_dialogue_list_export_general_options(inputs)
	if (locale === "zh-CN") return zh_cn2_dialogue_list_export_general_options(inputs)
	if (locale === "ja") return ja_dialogue_list_export_general_options(inputs)
	if (locale === "hi") return hi_dialogue_list_export_general_options(inputs)
	if (locale === "pt-PT") return pt_pt2_dialogue_list_export_general_options(inputs)
	return en_dialogue_list_export_general_options(inputs)
});